import React, {useEffect} from 'react';
import {Row, Col, Card, Table,  Icon,List} from 'antd'
import { TituloMenu,DivDetail, ColFlex,ImgResponsive,DivFlexColumn,DivResponsive, } from './style';
import CONSTANTES from '../../store/constantes';
import { useSelector, useDispatch } from 'react-redux';
import { actionGetDetailOrdenComplete } from '../../store/acciones/accionesOrdenes';
import NumberFormat from 'react-number-format';
import { DivPedidoContenido } from '../catalogo/style';

const columns = [
    {
      title: 'Producto',
      dataIndex: 'producto.Nombre',
      key: 'producto',
    },
    {
      title: 'Medida',
      dataIndex: 'producto.medida',
      key: 'medida',
    },
    {
      title: 'Cantidad',
      dataIndex: 'cantidad',
      key: 'cantidad',
    },
    {
      title: 'Subtotal',
      key: 'total',
      dataIndex: 'subtotal',
      render: total => (
        <span>
            <NumberFormat value={total} displayType={'text'} thousandSeparator={true} prefix={'$'} />
        </span>
      ),
    }
  ];


const OrdenDetail = (props) => {

    let detailOrdenComplete = useSelector(state => state.reducerOrdenes.ordenDetail);
    const dispatch = useDispatch();
      useEffect(() => {
          dispatch(actionGetDetailOrdenComplete(props.match.params.numorden));
      }, [dispatch, props.match.params.numorden]);

    if (detailOrdenComplete) {
        return (
            <>
                <Card title={<TituloMenu>Detalle de la orden {detailOrdenComplete.numerodeorden}</TituloMenu>} >
                    <Row type="flex" justify="center" align="middle">
                        <Col xl={20} lg={20} md={20} sm={24} xs={24}>
                            <DivDetail><span>Fecha :</span>{detailOrdenComplete.fechageneracion}</DivDetail>
                            <DivDetail><span>Cliente :</span>{detailOrdenComplete.cliente.NOMBRE}(Codigo: {detailOrdenComplete.cliente.CODIGO}) </DivDetail>
                            <DivDetail><span>Telefono :</span>{detailOrdenComplete.cliente.TELÉFONO}</DivDetail>
                            <DivDetail><span>RFC :</span>{detailOrdenComplete.cliente.RFC}</DivDetail>
                            <DivDetail><span>Domicilio :</span>
                            {detailOrdenComplete.cliente.DIRECCIÓN},
                            {detailOrdenComplete.cliente.COLONIA},
                            {detailOrdenComplete.cliente.CP},
                            {detailOrdenComplete.cliente.MUNICIPIO},
                            {detailOrdenComplete.cliente.POBLACIÓN},
                            </DivDetail>
                        </Col>
                        <Col xl={2} lg={2} md={2} sm={24} xs={24}>
                            <DivFlexColumn >
                                <a href={`${CONSTANTES.URL_API}/pedidos/pdf/${detailOrdenComplete.id}/`} target="blank" style={{ display: "flex", justifyContent: "center", flexDirection: "column", height: "auto", alignItems: "center" }}>
                                    <Icon type="file-pdf" style={{ fontSize: "50px" }} />
                                    <span style={{ fontSize: "20px" }}>Descargar</span>
                                </a>
                            </DivFlexColumn>
                        </Col>
                    </Row>

                </Card>
                <Card>
                    <Row type="flex" justify="center" align="middle" >
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <DivDetail><span>Vendedor :</span>{detailOrdenComplete.vendedor.first_name} {detailOrdenComplete.vendedor.last_name} ({detailOrdenComplete.vendedor.username})</DivDetail>
                            <DivDetail><span>Forma de pago :</span>{detailOrdenComplete.tipoorden}</DivDetail>
                            <DivDetail><span>Notas :</span>{detailOrdenComplete.comentario}</DivDetail>
                            <DivDetail><span>Dirección de entrega :</span>
                            {detailOrdenComplete.cliente.DIRECCIÓN},
                            {detailOrdenComplete.cliente.COLONIA},
                            {detailOrdenComplete.cliente.CP},
                            {detailOrdenComplete.cliente.MUNICIPIO},
                            {detailOrdenComplete.cliente.POBLACIÓN},
                            </DivDetail>
                        </Col>
                    </Row>
                </Card>
                <Card>
                    <Row type="flex" justify="center" align="middle" >
                        {
                            detailOrdenComplete.archivos && detailOrdenComplete.archivos.length > 0 ?
                                <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                                    <ImgResponsive src={detailOrdenComplete.archivos[0].impresion} />
                                </ColFlex> : null
                        }
                        {
                            detailOrdenComplete.archivos_dos && detailOrdenComplete.archivos_dos.length > 0 ?
                            <ColFlex xl={12} lg={12} md={12} sm={24} xs={24}>
                            <ImgResponsive src={detailOrdenComplete.archivos_dos[0].impresiondos} />
                            </ColFlex>:null

                        }
                    </Row>
                </Card>
                <Card>
                    <Row type="flex" justify="center" align="middle" >
                        <Col xl={24} lg={24} md={24} sm={24} xs={24}>
                            <h3>Detalles del pedido</h3>
                            <DivResponsive>
                                <div className="tableOrden">
                                    <Table columns={columns} dataSource={detailOrdenComplete.items} rowKey="id" />
                                </div>
                                <div className="listOrden">
                                    <List
                                        pagination={{
                                            pageSize: 10,
                                        }}
                                        grid={{
                                            gutter: 16,
                                            xs: 1,
                                            sm: 1,
                                        }}
                                        dataSource={detailOrdenComplete.items}
                                        renderItem={item => (
                                            <List.Item>
                                                <Card title={item.cliente}>
                                                    <Row type="flex" justify="space-around" align="middle">
                                                        <Col xl={20} lg={20} md={20} sm={24} xs={24}>
                                                            <DivPedidoContenido>
                                                            <p>Producto: <span>{item.producto.Nombre}</span></p>
                                                            <p>Medida: <span>{item.producto.medida}</span></p>
                                                            <p>Cantidad: <span>{item.cantidad}</span></p>
                                                            <p>Subtotal: <span><NumberFormat value={item.subtotal} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span></p>
                                                            </DivPedidoContenido>
                                                           
                                                        </Col>
                                                    </Row>
                                                </Card>
                                            </List.Item>
                                        )}
                                    />
                                </div>                        
                            </DivResponsive>                             
                        </Col>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24} style={{display:"flex", flexDirection:"column", alignItems:"flex-end"}}>
                            <DivDetail><span>Subtotal :</span><NumberFormat value={detailOrdenComplete.total-detailOrdenComplete.cargos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></DivDetail>
                            <DivDetail><span>Cargos:</span> <NumberFormat value={detailOrdenComplete.cargos} displayType={'text'} thousandSeparator={true} prefix={'$'} /></DivDetail>
                        </Col>
                        <Col xl={24} lg={24} md={24} sm={24} xs={24} style={{display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center"}}>
                            <span style={{fontSize:"30px", fontWeight:"bold"}}>Total:</span>
                            <NumberFormat value={detailOrdenComplete.total} displayType={'text'} thousandSeparator={true} prefix={'$'}  style={{fontSize:"40px",fontWeight:"bold"}}/>
                        </Col>
                        
                        
                    </Row>
                </Card>
            </>

        );

    }
    else {
        return <div><Icon type="sync" spin theme="twoTone" style={{ fontSize: '200px' }} /></div>
    }
    
};

export default OrdenDetail;